module.exports = __webpack_public_path__ + "img/patrulla_pcivil_down_selected.309a09e0.svg";